import React from 'react';
import Machineries from '../components/Core/ServicesAndProduct/Machineries';
import MeasuringEquipment from '../components/Core/ServicesAndProduct/MeasuringEquipment';

const ServiceAndProduct = () => {
  return (
    <div>
      {/* Hero Section */}
      <div className='w-full min-h-[400px] flex items-center justify-center bg-gradient-to-br from-slate-800 to-slate-950 px-4 md:px-10'>
        <div className='text-center max-w-lg md:max-w-2xl'>
          <h1 className='text-white font-bold text-lg md:text-xl lg:text-3xl'>Our Automation Services And IT Solutions</h1>
          <h2 className='text-white font-bold text-2xl md:text-4xl lg:text-5xl mt-5 mb-5'>We focus on providing solutions that automate</h2>
          <h2 className='text-slate-200 font-bold text-sm md:text-lg text-center'>
            Our team focuses on providing solutions that automate industry processes and offer IT solutions.
          </h2>
        </div>
      </div>

      {/* Services Sections */}
      <div className='w-full px-4 md:px-10'>
        <Machineries />
        <MeasuringEquipment />
      </div>
    </div>
  );
};

export default ServiceAndProduct;